<template>
  <header id="wrapper">
    <!--<div class="safe-wrap" style="display: none;">
      <div class="safe-top clearfloat">
        <p class="fl" style="font-size: 13px">该网站已经认证联盟认证为实名网站，请放心访问</p>
        <p class="fr" style="font-size: 13px">
          <a target="_blank" href="https://aacc.introes.com/chat/Hotline/channel.jsp?cid=5041762&amp;cnfid=17357&amp;j=7042257554&amp;s=1">
            了解详情
          </a>
          <span>
             <a target="_blank" href="https://aacc.introes.com/chat/Hotline/channel.jsp?cid=5041762&amp;cnfid=17357&amp;j=7042257554&amp;s=1">
                <img border="0" class="mt6" src="../assets/img/sy_smwz.png"></a></span>
        </p>
      </div>
    </div>-->
<!--    <span class="hide active" @click="changeHide"><a href="#">隐藏</a></span>-->
    <div class="header-top">
      <div class="header-warp">
        <span class="header-top-content" v-html="header_description"></span>
          <ul class="header-top-list">
            <li class="header-entrance-li" v-show="!$store.state.loginType">
              <router-link to="/login" class="entrance">
                登录
              </router-link>
            </li>
            <li class="header-entrance-li" v-show="$store.state.loginType">
              <router-link to="/myaccount" class="entrance">
                港股账户
              </router-link>
            </li>
            <li class="header-entrance-li">
              |
            </li>
            <li class="header-entrance-li" v-show="!$store.state.loginType">
              <router-link to="/login/register" class="entrance">
                注册
              </router-link>
            </li>
            <li class="header-entrance-li" v-show="$store.state.loginType">
              <a @click="exitLogin" class="entrance" href="javascript:void(0);">
                退出
              </a>
            </li>
            <li class="header-entrance-li">
              |
            </li>
            <!-- <li class="header-entrance-li">
              <router-link to="/help/helpabout" class="entrance">
                关于我们
              </router-link>
            </li> -->
             <li class="header-entrance-li">
              <a href="javascript:void(0);" class="entrance" @click="getDnzqUrl" title="金牛证券官网">
               金牛证券官网
              </a>
            </li>
            <li class="header-entrance-li">
              |
            </li>
            <li class="header-entrance-li">
              <a href="javascript:void(0);" class="entrance" @click="displayLinePopup" style="color: #e06373">{{activeLineUrlName}}</a>
           </li>
          </ul>
      </div>
    </div>
    <div class="site-nav box-shadow">
      <div class="container-w">
        <el-row :gutter="100" style="margin-left: -50px;margin-right: -400px;">
          <el-col :span="4">
            <a href="/" class="brand">
              <img v-if="headerLogo != ''" :src="headerLogo">
              <img v-if="headerLogo == ''" src="../assets/img/cuc_logo.png">
            </a>
          </el-col>
          <el-col :span="20">
            <div class="flex-row ml-md-auto active">
              <ul id="main-menu" class="nav nav-main active">
                <li class="menu-item menu-item-level-1" :class="{ 'active':'Home'===isActive  }" @click="changeActivet('Home')">
                  <router-link to="/home">
                    首页
                  </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ 'active':'Stockrise'===isActive  }" @click="changeActivet('Stockrise')">
                  <router-link to="/stockmarket/allhkstock">
                    港股行情
                  </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ 'active':'Operateday'===isActive  }" @click="changeActivet('Operateday')">
                  <router-link to="/operate">
                    申请配资
                  </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ active: '/myaccount/strategynow' === isActive  }" @click="changeActivet('/myaccount/strategynow')">
                    <a href="javascript:void(0);" @click="goStrategynow">
                         配资账户
                   </a>
                 </li>
                <li class="menu-item menu-item-level-1" :class="{ 'active':'Stockdetailed'=== isActive }" @click="changeActivet('Stockdetailed')">
                  <router-link :to="{name:'Stockdetailed',query:{symbol:'hk00001',direction:0}}">
                    做多交易
                  </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ 'active':'Stockdetailed1'=== isActive }" @click="changeActivet('Stockdetailed1')">
                  <router-link :to="{name:'Stockdetailed',query:{symbol:'hk00001',direction:1}}">
                    做空交易
                  </router-link>
                </li>
                <!-- <li class="menu-item menu-item-level-1" :class="{ 'active':'winners_diagnosis'=== isActive }" @click="changeActivet('winners_diagnosis')">
                  <router-link to="/winners_diagnosis">
                    牛股诊股
                  </router-link>
                </li> -->
                <li class="menu-item menu-item-level-1" :class="{ 'active':'stockactivity'===isActive }" @click="changeActivet('stockactivity')">
                  <router-link to="/stockactivity">
                    活动专区
                  </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ 'active':'Download'===isActive }" @click="changeActivet('Download')">
                  <router-link to="/download" >
                    APP下载
                  </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ 'active':'Login'=== isActive }" @click="changeActivet('Login')">
                  <router-link to="/login" >
                    港股账户
                  </router-link>
                </li>
                <!--<li class="menu-item menu-item-level-1" :class="{ 'active':'Agency'=== isActive }" @click="changeActivet('Agency')">
                  <a href="javascript:void(0);" @click="goAgency">我要推广</a>
                </li>-->
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <linePopup ref="lineListPopup"></linePopup>
  </header>
</template>
<script>
import linePopup from "./common/linepopup";
export default {
  name: "Header",
  components: {
     linePopup,
   },
  data() {
    return {
      isActive:'home',
      header_description:'',
      headerLogo:'',
       activeLineUrlName: localStorage.getItem('lineUrlText')
    };
  },
  mounted: function() {
    this.get_logo();
    this.getRoute();
    this.headerDescription();
  },
  methods: {
       goStrategynow() {
       if (this.$store.state.loginType) {
           this.$store.state.accountType = 3;
         this.$router.push({
           path: "/myaccount/strategynow",
         });
       } else {
         this.$router.push({
           path: "/login",
         });
       }
     },
      get_logo() {
        let that = this;
        that.$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: 'logo',
            logo_name: 'home_logo,login_register_logo'
          }
        })
          .then(ret => {
            let resData = ret.data;
            if (resData.code === 1) {
              that.headerLogo = resData.data.home_logo;
            }
          });
      },
    headerDescription(){
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            name:"pc_web_header_description"
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.header_description = res.data.data;
          } else {
          }
        });
    },
    displayLinePopup() {
       this.$refs.lineListPopup.showlineListPopup();
     },
    //注销登录
    exitLogin() {
      this.$store.state.loginType = false;
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("loginType");
      sessionStorage.removeItem("couponCheck");
      this.$router.push({
        path: "/login"
      });
    },
    changeActivet(value){
      let that = this;
      that.isActive = value;
    },
    changeHide(){
      $('.safe-wrap').toggle();
      $('.hide').toggleClass('active')
    },
    goAgency(){
      if (this.$store.state.loginType){
        this.$router.push({
          path: "/myaccount/agency"
        });
      }else{
        this.$router.push({
          path: "/login"
        });
      }
    },
    getRoute(){
      if(this.$route.query.direction==1){
        this.isActive = "Stockdetailed1"
      }else if(this.$route.query.direction==0){
        this.isActive = "Stockdetailed"
      }else{
        this.isActive = this.$route.name;
      }
    },
    getDnzqUrl(){
      let that = this;
        that.$http({
          url: "/",
          method: "POST",
          data: {
            'nozzle': 'sysconfig',
            'name':'dnzq_official_url'
          }
        })
          .then(ret => {
            let resData = ret.data;
            if (resData.code === 1) {
            window.open( resData.data , '_blank ');

            }
          });
    },
  },
  watch:{
    $route(to,from){
      if(this.$route.query.direction==1){
        this.isActive = "Stockdetailed1"
      }else if(this.$route.query.direction==0){
        this.isActive = "Stockdetailed"
      }else if (this.$route.name == "Stockdetailed") {
        this.isActive = "Stockdetailed";
      }else if(this.$route.name=="Operateday"){
        this.isActive = "Operateday"
      }
    }
  }
};
</script>
<style lang="less" scoped>
  @import url("./../assets/css/style.css");
  .logo-box{
    float: left;
    position: absolute;
    bottom:0;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
  .logo{
    width: 300px;
    height: 50px;
  }
  .header-top{
    height: 35px;
    background: rgba(0,0,0,0.75);
  }
  .header-warp{
    width: 100%;
    max-width: 1200px;
    min-width: 1000px;
    margin: auto;
  }
  .header-top-content{
    color: #fff;
    font-size: 14px;
    line-height: 35px;
    letter-spacing: 1px;
    float: left;
  }
  .header-top-list{
    float: right;
    display: flex;
    display: -webkit-box;
    display: -ms-flexbox;
  }
  .header-entrance-li{
    line-height: 35px;
    color: #fff;
  }
  .entrance{
    color: #fff;
    margin: 0 10px;
  }
  .entrance:hover{
    opacity: 0.8;
  }
#wrapper {
  z-index: 9;
  width: 100%;
  min-width: 1000px;
  position: relative;
  background: rgba(255, 255, 255);
  .wrapper-header {
    width: 100%;
    max-width: 1200px;
    min-width: 1000px;
    margin: auto;
    height: 80px;
    position: relative;
    p {
      background: url(../assets/img/login_01.png) center center no-repeat;
      background-size: auto 45px;
      width: 219px;
      height: 80px;
      float: left;
    }
    ul {
      display: block;
      float: right;
      li {
        display: inline-block;
        height: 80px;
        margin-right: 20px;
        a {
          display: inline-block;
          height: 80px;
          font-size: 20px;
          line-height: 80px;
          width: 100%;
          color: #666;
          text-align: center;
          position: relative;
          min-width: 60px;
          span {
            display: inline-block;
            width: 60px;
            height: 0;
            position: absolute;
            right: 0;
            left: 0;
            margin: 0 auto;
            bottom: 20px;
            border-bottom: 1px solid transparent;
          }
        }
        .header_active {
          color: #e85b25;
          span {
            border-bottom: 1px solid #e85b25 !important;
          }
        }
      }
    }
  }
}
header > div > button {
  background-color: transparent;
  font-size: 15px;
  cursor: pointer;
  color: white;
  display: inline-block;
  line-height: 80px;
  float: right;
}
  .safe-wrap{
    position: relative;
    width:100%;
    min-width: 1200px;
    color:#fff;
    background:#f0eadc;
  }
  .safe-top{
    height: 50px;
    line-height: 50px;
    padding:0 100px 0 60px;
    background: url(../assets/img/sy_aq.png) 20px center no-repeat #21ad49;
  }
  .safe-top p {
    height:50px;
  }
  .safe-top p a{
    display: inline-block;
    color:#ffe6ae;
    vertical-align: top;
    margin-right:5px;
  }
  .safe-top p span {
    display: inline-block;
    height:50px;
  }
  .safe-list ul{
    width:100%;
    list-style: none;
  }
  .safe-list ul li{
    float: left;
    width:22%;
    height:25px;
    line-height: 25px;
    text-align: center;
  }
  .safe-list ul li a{
    font-size:14px;
    color:#5fbf89;
  }
  span.hide{
    position: absolute;
    top:0;right:10px;
    z-index: 9;
    display: inline-block;
    width:40px;
    padding:20px 10px;
    color:#fff;
    font-size:14px;
    font-weight: bold;
    text-align: center;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
    background:url(../assets/img/sy_yc_up.png) center 7px no-repeat #3bbe60;
    padding-top:25px;
    cursor: pointer;
  }
  span.hide a{
    color:#fff;
    font-size:14px;
  }
  span.hide.active{
    background: url(../assets/img/sy_yc_down.png) center 15px no-repeat #3BBE60!important;
  }
  span.hide.active a{
    display:none!important;
  }.fr{
     float: right!important;
   }
  .fl{
    float: left!important;
  }
  .txt-r{
    text-align: right!important;
  }
  .txt-l{
    text-align: left!important;
  }
  .txt-c{
    text-align: center!important;
  }
  .menu-item{
    float: left;
  }
</style>





// WEBPACK FOOTER //
// src/components/header.vue